module.exports = __webpack_public_path__ + "img/small-cross.1da982db.svg";